var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMvKey = function SvgMvKey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 44",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "mv-key")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.05,7,33,2.94A10.07,10.07,0,0,0,17.79,16.08L.42,33.42a1.44,1.44,0,0,0,0,2l4.07,4.07a1.45,1.45,0,0,0,2,0l1-1,5.09,5.08a1.45,1.45,0,0,0,2,0l3-3-5.38-5.41a1.44,1.44,0,0,1,2-2l5.39,5.41,3-3a1.44,1.44,0,0,0,0-2l-5.09-5.08,6.18-6.17A10.06,10.06,0,0,0,37.05,7ZM33,17.16a4.3,4.3,0,0,1-5.44.54c-.55-.36-4.26-4.13-4.73-4.6a4.31,4.31,0,0,1,0-6.09h0a4.32,4.32,0,0,1,6.1,0c.52.52,4.25,4.18,4.62,4.73A4.3,4.3,0,0,1,33,17.16Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMvKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mv-key.61b9ee6c.svg";
export { ForwardRef as ReactComponent };